import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommunityLogoComponent } from '@app/layout/components/community-logo/community-logo.component';
import { CommunityHeaderComponent } from '@app/layout/components/community-header/community-header.component';
import { CommunityHeaderLinksComponent } from '@app/layout/components/community-header-links/community-header-links.component';
import { LoginProfileBlockComponent } from '@outlaw/community';
import { DataTestDirective } from '@outlaw/core';
import { BackButtonComponent } from '@shared/components';

@NgModule({
  declarations: [CommunityHeaderComponent, CommunityHeaderLinksComponent],
  imports: [
    CommonModule,
    RouterModule,
    LoginProfileBlockComponent,
    CommunityLogoComponent,
    BackButtonComponent,
    DataTestDirective,
  ],
  exports: [CommunityLogoComponent, CommunityHeaderComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class LayoutModule {}
